
<div id="myTab_Content2" >
  <div class="glgxBox sonMod1Box">
    <div class="w1224">
      <h2 class="titBlue"><div class="floatL"><i></i><span>股权结构</span></div><div class="floatR"></div></h2>
      <div class="glgxCon">
        <!--<img src="../../../assets/images/glgx.png" alt="股权结构"/>-->
        <div id="stockRight" style="width: 100%; height: 500px;"></div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enter-stockright-structure/enter-stockright-structure.component.html